import { navCopy as enNavCopy } from "../en/nav"

export const navCopy = {
  ...enNavCopy,
  skip_to_content: "Sk1p t0 main Con7ent",
  nav_documentation: "D0cumentation",
  nav_documentation_short: "Docs",
  nav_download: "DL",
  nav_community: "Konnect",
  nav_tools: "Playground",
  nav_search_placeholder: "Se4rch D0cz",
  nav_beta_notification:
    "Note: this page is a b3ta page, don't rely on the URL and <a>file issues on microsoft/TypeScript-Website</a>",
}
